import React from 'react';
import BaseIcon from 'common/BaseIcon';
import styled from '@emotion/styled';

const SearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border: 1px solid #babcbf;
  border-radius: 2px;

  input {
    border: none;
    padding: 0 !important;

    &::placeholder {
      color: #A1A3A6;
      font-style: italic;
    }
  }

  i {
    color: #5B6770;
  }
`;

const CountrySearch = React.forwardRef(({ value, onChange, placeholder }, ref) => (
  <SearchInputWrapper>
    <input
      ref={ref}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
    <BaseIcon icon="search" />
  </SearchInputWrapper>
));

export default CountrySearch;
